import cert from '../assets/png/ALXSE_Certificate-Koech.png'
import challenge from '../assets/png/100DaysofALXSE.png'


export const achievementData = {
    bio: 'Continuous learning and calculated risk-taking define my approach. I believe the only strategy guaranteed to fail is standing still—so I keep building, leading, and shipping.',
    achievements: [
        {
            id: 1,
            title: 'Career transition into Software Engineering',
            details: 'Successfully transitioned from industrial chemistry to software engineering through structured learning (ALX-Africa), self-study, and hands-on projects. Leveraged analytical and quality-assurance experience to deliver production systems and lead engineering initiatives.',
            date: 'Feb 5, 2023',
            field: 'Software Engineering',
            image: cert
        },
        {
            id: 2,
            title: '100 Days of ALX Software Engineering',
            details: 'Completed a disciplined 100-day coding commitment—at least one hour of focused programming daily—strengthening fundamentals and building a consistent engineering practice.',
            date: 'Mar 14, 2024',
            field: 'Software Development',
            image: challenge
        },
        // {
        //     id : 3,
        //     title : 'Machine Learning A-Z: Hands-On Python & R in Data Science',
        //     details : 'Data Science Course from Udemy',
        //     date : 'Apr 13, 2021',
        //     field : 'Machine Learning',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-d9a7ba99-8635-47e6-96fc-7dd26a3dcbf1.jpg?v=1618297236000'
        // },
        // {
        //     id : 3,
        //     title : 'R Programming A-Z: R For Data Science With Real Exercises!',
        //     details : 'R Programming Language Course from Udemy',
        //     date : 'Feb 28, 2021',
        //     field : 'Data Science',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-8f5ff8e8-b6a4-4efd-a3fc-7fb63b29e77f.jpg?v=1614489452000'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/